import React, { Component } from "react";
import {FaUsers, FaBuilding,  FaMagnet, FaUser } from "react-icons/fa";
import Title from "./Title";
export default class Services extends Component {
  state = {
    services: [
      {
        icon: <FaBuilding />,
        title: "To Companies",
        info:
          "We take pride in helping small and mid-size companies mine throught the resume noise and instantly identify who to interview, saving time during hiring ensuring they look at the best canditates first"
      },
      {
        icon: <FaMagnet />,
        title: "To Recruiters",
        info:
          "We make it easy to review candidates who are the best match for the role. Helping them have more time in their day instead of scanning 100s of resumes for high volume positions "
      },
      {
        icon: <FaUsers />,
        title: "Talent Managers",
        info:
          " Profile candidates by providing multiple data points to help make a decision in the screening process"
      },
      {
        icon: <FaUser />,
        title: "Candidates",
        info:
          " Chatbot conversation to give automatic feedback to unsuccessful candidates "
      }
    ]
  };
  render() {
    return (
      <section className="services">
        <Title title="services" />
        <div className="services-center">
          {this.state.services.map(item => {
            return (
              <article key={`item-${item.title}`} className="service">
                <span>{item.icon}</span>
                <h6>{item.title}</h6>
                <p>{item.info}</p>
              </article>
            );
          })}
        </div>
      </section>
    );
  }
}
